import React, { ReactNode } from "react";
import styles from "./AppBouton.scss";

export type AppBoutonProps = {
  tooltip?: string;
  typeBouton: "PRIMAIRE" | "SECONDAIRE" | "PRIMAIRE_ALT" | "SECONDAIRE_ALT" | "PRIMAIRE_PETIT" | "SECONDAIRE_PETIT_ALT";
  children: ReactNode;
} & React.ComponentProps<"button">;

const AppBouton = ({ tooltip = "", typeBouton, children, ...reste }: AppBoutonProps) => {
  return (
    <>
      {tooltip !== "" && (
        <div data-text={tooltip} className={styles.tooltip}>
          <button className={styles[typeBouton]} {...reste}>
            {children}
          </button>
        </div>
      )}
      {tooltip === "" && (
        <button className={styles[typeBouton]} {...reste}>
          {children}
        </button>
      )}
    </>
  );
};

export default AppBouton;
